import * as React from "react";
const SvgFiRrMeterDroplet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-meter-droplet_svg__a)">
      <path
        fill="#062147"
        d="M11.996 23.045a1 1 0 0 1-.995.91q-.045.001-.091-.004C4.69 23.391 0 18.253 0 12 0 5.383 5.383 0 12 0c6.253 0 11.391 4.69 11.951 10.91a1 1 0 0 1-1.992.18C21.492 5.908 17.211 2 12 2 6.486 2 2 6.486 2 12c0 5.211 3.908 9.492 9.09 9.959a1 1 0 0 1 .906 1.086M5 8v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m4 0v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m4 0v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m4 0v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m7 10.6a5.46 5.46 0 0 1-1.611 3.889A5.46 5.46 0 0 1 18.5 24.1a5.46 5.46 0 0 1-3.889-1.611A5.46 5.46 0 0 1 13 18.6a5.46 5.46 0 0 1 1.611-3.889l1.9-1.859a2.86 2.86 0 0 1 3.977 0l1.893 1.852A5.47 5.47 0 0 1 24 18.6m-2 0c0-.935-.364-1.813-1.025-2.475l-1.885-1.844a.84.84 0 0 0-1.18 0l-1.893 1.852a3.47 3.47 0 0 0-1.018 2.467c0 .935.364 1.813 1.025 2.475 1.322 1.322 3.627 1.323 4.949 0a3.48 3.48 0 0 0 1.025-2.475z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-meter-droplet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMeterDroplet;
